/* eslint-disable no-restricted-imports */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React, {useMemo} from "react";
import { useNavigate } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import {useSelector} from "react-redux";
import objectPath from "object-path";
import {useHtmlClassService} from "../../../_core/MetronicLayout";
import {toAbsoluteUrl} from "../../../../_helpers";
import {DropdownTopbarItemToggler} from "../../../../_partials/dropdowns";

export function UserProfileDropdown() {
  const {user} = useSelector(state => state.auth);
  const navigate = useNavigate();
  const userData = user?.userData || user;
  const username = userData?.name || "User";
  const userid = userData?.userid;
  const isAdmin = userData?.is_admin;

  const uiService = useHtmlClassService();
  const layoutProps = useMemo(() => {
    return {
      light: objectPath.get(uiService.config, "extras.user.dropdown.style") === "light",
    };
  }, [uiService]);

  const myProfileUrl = userid
    ? (isAdmin ? `/admin/${userid}/edit` : `/user/${userid}/edit`)
    : "#";

  return (
      <Dropdown drop="down" align="end">
        <Dropdown.Toggle
            as={DropdownTopbarItemToggler}
            id="dropdown-toggle-user-profile"
        >
          <div className="btn btn-icon w-auto btn-clean d-flex align-items-center btn-lg px-2">
            <span className="text-muted font-weight-bold font-size-base d-none d-md-inline mr-1">xxHi,</span>
            <span className="text-dark-50 font-weight-bolder font-size-base d-none d-md-inline mr-3">
              {username}
            </span>
            <span className="symbol symbol-35 symbol-light-success">
              <span className="symbol-label font-size-h5 font-weight-bold">{username[0] || "?"}</span>
            </span>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu
            className="p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl">
          <>
            {/** ClassName should be 'dropdown-menu p-0 m-0 dropdown-menu-right dropdown-menu-anim dropdown-menu-top-unround dropdown-menu-xl' */}
            {layoutProps.light && (<>
              <div className="d-flex align-items-center p-8 rounded-top">

                <div className="symbol symbol-md bg-light-primary mr-3 flex-shrink-0">
                  <span className="symbol-label font-size-h5 font-weight-bold text-primary">{username[0] || "?"}</span>
                </div>
                <div className="text-dark m-0 flex-grow-1 mr-3 font-size-h5">{username}</div>
              </div>
              <div className="separator separator-solid"></div>
            </>)}

            {!layoutProps.light && (
                <div
                    className="d-flex align-items-center justify-content-between flex-wrap p-8 bgi-size-cover bgi-no-repeat rounded-top"
                    style={{
                      backgroundImage: `url(${toAbsoluteUrl("/media/misc/bg-1.jpg")})`
                    }}
                >
                  <div className="symbol bg-white-o-15 mr-3">
                    <span className="symbol-label text-success font-weight-bold font-size-h4">{username[0] || "?"}</span>
                  </div>
                  <div className="text-white m-0 flex-grow-1 mr-3 font-size-h5">
                    {username}
                  </div>
                </div>
            )}
          </>

          <div className="navi navi-spacer-x-0 pt-5">
            <a
              href="#"
              className="navi-item px-8"
              onClick={(e) => {
                e.preventDefault();
                if (myProfileUrl !== "#") navigate(myProfileUrl);
              }}
            >
              <div className="navi-link">
                <div className="navi-icon mr-2">
                  <i className="flaticon2-calendar-3 text-success"/>
                </div>
                <div className="navi-text">
                  <div className="font-weight-bold">My Profile</div>
                  <div className="text-muted">Account settings and more</div>
                </div>
              </div>
            </a>
            <a
              href="#"
              className="navi-item px-8"
              onClick={(e) => {
                e.preventDefault();
                navigate("/logout");
              }}
            >
              <div className="navi-link">
                <div className="navi-icon mr-2">
                  <i className="flaticon2-left-arrow text-danger"/>
                </div>
                <div className="navi-text">
                  <div className="font-weight-bold">Logout</div>
                  <div className="text-muted">Sign out of your account</div>
                </div>
              </div>
            </a>
          </div>
        </Dropdown.Menu>
      </Dropdown>
  );
}
